// extracted by mini-css-extract-plugin
export default {"chartparent":"Demo_chartparent__+hDje","chartdiv":"Demo_chartdiv__aDNy7","Demo_chartdiv__UUZWB":"Demo_Demo_chartdiv__UUZWB__PJm7F"};